var map = {
	"./BOOST.svg": 2361,
	"./GRAB.svg": 2362,
	"./MBB.svg": 2363,
	"./TNG.svg": 2364,
	"./direpay.svg": 2365,
	"./doitnow.svg": 2366,
	"./duitnow.svg": 2367,
	"./fpay.svg": 2368,
	"./fpay2.svg": 2369,
	"./fpx.svg": 2370,
	"./online_banking.svg": 2371,
	"./rapidpays.svg": 2372,
	"./secret_pay.svg": 2373,
	"./secret_pay_offline.svg": 2374,
	"./secret_pay_pro.svg": 2375,
	"./secret_pay_pro_b.svg": 2376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;